$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  const location_id = $('body').attr('event_id');

  if (p === 'customer' && a === 'list') {
    $(document).on('submit', '#customer-search-form', function (e) {
      e.preventDefault();
      let search_string = $('#search_string').val();
      let page = 1;

      getCustomerList(location_id, search_string, page);
    });

    function getCustomerList(location_id, search_string, page) {
      $.ajax({
        type: 'POST',
        url: '/ajax/customer/search',
        data: {
          location_id,
          search_string,
          page,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#customer-search-button').val(search_string);
            $('#customer-list-container').empty();
            $('#customer-list-container').append(data.html);
          }

          $('html,body').scrollTop(0);
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
